import { useQuery } from "@tanstack/react-query";
import { fetchClient } from "../../API/fetchClient";
import type { Filiere } from "../../types/entities";

export const useGetFilieres = () =>
  useQuery({
    queryKey: ["filieres"],
    queryFn: async (): Promise<Filiere[]> => {
      const resp = await fetchClient<Filiere[]>("/iam/filiere/");
      if (resp.error || !resp.data) throw resp.error || new Error("Failed to fetch Filieres");
      return resp.data;
    },
    staleTime: 5 * 60 * 1000,
  });

export default useGetFilieres;
